export enum SequenceType {
  AutomaticProgressive = 1,
  Multichannel = 2,
}

export const SequenceTypeText = {
  [SequenceType.AutomaticProgressive]: "Progresivo automático",
  [SequenceType.Multichannel]: "Secuencia multicanal",
};

export enum SequenceStep {
  Configuration = "Configuración",
  Schedule = "Horario (Opcional)",
  Identifiers = "Identificadores (Opcional)",
  Users = "Usuarios (Opcional)",
}

export enum ContactStatus {
  Pending = 1,
  InProgress = 2,
  Contacted = 3,
  Finalized = 4,
}

export const HistoryActionColor = {
  1: "#1677ff",
  2: "#fa8c16",
  3: "#f863b0",
}